module.exports = __webpack_public_path__ + "static/media/dress-code-women1.67a8f283.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/dressCode/dress-code-women1.png
// module id = 702
// module chunks = 0